"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectTeaser = void 0;
var _react = _interopRequireDefault(require("react"));
var _format_amount = require("../helpers/format_amount");
var _trusted_html = require("./trusted_html");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ProjectTeaser = exports.ProjectTeaser = function ProjectTeaser(_ref) {
  var _project$links$find, _project$profile_pict, _project$carrier, _project$carrier2, _project$carrier3;
  var project = _ref.project,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? document.documentElement.lang || 'de' : _ref$locale,
    href_ = _ref.href,
    onClick = _ref.onClick,
    className = _ref.className,
    showDescription = _ref.showDescription,
    openInTab = _ref.openInTab,
    bottomContent = _ref.bottomContent,
    children = _ref.children,
    showCarrierName = _ref.showCarrierName;
  var openAmount = (0, _format_amount.formatAmount)({
    cents: project.open_amount_in_cents,
    locale: locale
  });
  var donationsCount = new Intl.NumberFormat(locale).format(project.donations_count);
  var openAmountCaption = locale === 'de' ? 'fehlen noch' : 'still needed';
  var donationsCountCaption = locale === 'de' ? 'Spenden' : 'donations';
  var href = href_ || ((_project$links$find = project.links.find(function (link) {
    return link.rel === 'platform';
  })) === null || _project$links$find === void 0 ? void 0 : _project$links$find.href);
  var projectImageUrl = (_project$profile_pict = project.profile_picture) === null || _project$profile_pict === void 0 || (_project$profile_pict = _project$profile_pict.links.find(function (link) {
    return link.rel === 'fill_410x214';
  })) === null || _project$profile_pict === void 0 ? void 0 : _project$profile_pict.href;
  var orgaImageUrl = (_project$carrier = project.carrier) === null || _project$carrier === void 0 || (_project$carrier = _project$carrier.picture) === null || _project$carrier === void 0 || (_project$carrier = _project$carrier.links.find(function (link) {
    return link.rel === 'fill_100x100';
  })) === null || _project$carrier === void 0 ? void 0 : _project$carrier.href;
  var handleClick = function handleClick(event) {
    onClick && onClick(event, project);
  };
  return /*#__PURE__*/_react["default"].createElement("a", {
    title: project.title,
    onClick: handleClick,
    className: "donatable-teaser ".concat(className !== null && className !== void 0 ? className : '', " ").concat(showDescription ? 'donatable-teaser--with-description' : '', " ").concat(bottomContent ? 'donatable-teaser--with-bottom-content' : ''),
    href: href,
    target: openInTab ? '_blank' : '_parent',
    rel: "noreferrer"
  }, children /* mount point, e.g. for injecting VisibilitySensor */, /*#__PURE__*/_react["default"].createElement("div", {
    className: "donatable-teaser--profile-picture",
    style: {
      backgroundImage: "url(".concat(projectImageUrl, ")")
    },
    title: project.title
  }), /*#__PURE__*/_react["default"].createElement(_trusted_html.TrustedHtml, {
    as: "h2",
    className: "donatable-teaser--title",
    value: project.title
  }), showDescription && /*#__PURE__*/_react["default"].createElement(_trusted_html.TrustedHtml, {
    className: "donatable-teaser--description",
    as: "div",
    value: project.description
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "donatable-teaser--divider"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "donatable-teaser--factlist"
  }, /*#__PURE__*/_react["default"].createElement("div", null, project.city && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, project.city), ",", ' '), project.country), /*#__PURE__*/_react["default"].createElement("div", null, showCarrierName ? /*#__PURE__*/_react["default"].createElement("span", null, (_project$carrier2 = project.carrier) === null || _project$carrier2 === void 0 ? void 0 : _project$carrier2.name) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, donationsCount), " ", donationsCountCaption)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, openAmount), " ", openAmountCaption)), /*#__PURE__*/_react["default"].createElement("img", {
    src: orgaImageUrl,
    alt: (_project$carrier3 = project.carrier) === null || _project$carrier3 === void 0 ? void 0 : _project$carrier3.name,
    className: "donatable-teaser--carrier-logo"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "donatable-teaser--progress"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "donatable-teaser--progress-bar",
    style: {
      width: "".concat(project.progress_percentage, "%")
    }
  })), bottomContent);
};